export const aboutData = {
  brandIntro: {
    title: '关于po18官网',
    paragraphs: [
      'po18官网是国内领先的移动阅读平台，致力于为广大书迷提供优质、便捷、安全的在线阅读服务。自成立以来，我们始终秉持"让阅读更美好"的理念，汇聚海量正版小说资源，打造极致的阅读体验。',
      '我们的团队由一群热爱阅读的技术专家和内容运营专家组成。通过持续的技术创新和内容优化，po18官网app已成为数千万用户信赖的阅读伴侣。',
      'po18官网app覆盖玄幻、言情、都市、科幻、仙侠、悬疑、历史、游戏等数十个热门分类，与数百家知名文学网站和出版社建立了深度合作关系，确保内容的丰富性和正版性。',
    ],
  },
  milestones: [
    { year: '2018', event: 'po18官网正式上线，推出网页版阅读服务' },
    { year: '2019', event: '发布po18官网app 1.0版本，迈入移动阅读时代' },
    { year: '2020', event: '注册用户突破500万，上线VIP会员体系' },
    { year: '2021', event: '推出智能推荐算法，个性化推荐精准度大幅提升' },
    { year: '2022', event: '注册用户突破2000万，获得年度最佳阅读应用奖' },
    { year: '2023', event: '推出离线阅读与听书功能，全面升级阅读体验' },
    { year: '2024', event: '用户覆盖全球30+国家和地区，与200+出版机构达成合作' },
    { year: '2025', event: '注册用户突破5000万，持续引领移动阅读行业' },
  ],
  testimonials: [
    {
      name: '李同学',
      role: '大学生',
      avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20college%20student%20portrait%2C%20friendly%20smile%2C%20clean%20white%20background%2C%20warm%20natural%20lighting%2C%20casual%20style%2C%20professional%20headshot&width=200&height=200&seq=avatar-01&orientation=squarish',
      content: '用了po18两年了，书库真的很全，想看的书基本都能找到。阅读体验也很舒服，特别是夜间模式，晚上看小说眼睛也不累。强烈推荐！',
      rating: 5,
    },
    {
      name: '王女士',
      role: '职场白领',
      avatar: 'https://readdy.ai/api/search-image?query=A%20professional%20Chinese%20woman%20portrait%2C%20confident%20expression%2C%20modern%20office%20style%2C%20clean%20white%20background%2C%20soft%20warm%20lighting%2C%20professional%20headshot&width=200&height=200&seq=avatar-02&orientation=squarish',
      content: '通勤路上必用app！离线下载功能太实用了，地铁上信号不好的时候也能看。而且平台推荐的书籍都很对我胃口，省去了找书的麻烦。',
      rating: 5,
    },
    {
      name: '张先生',
      role: '自由职业者',
      avatar: 'https://readdy.ai/api/search-image?query=A%20casual%20Chinese%20man%20portrait%2C%20relaxed%20friendly%20expression%2C%20clean%20white%20background%2C%20warm%20natural%20lighting%2C%20creative%20style%2C%20professional%20headshot&width=200&height=200&seq=avatar-03&orientation=squarish',
      content: '从最初的网页版一直用到现在，见证了po18的成长。现在的app功能越来越完善，特别是听书功能，做家务的时候也能"读"书，太方便了。',
      rating: 5,
    },
  ],
  contactInfo: {
    email: 'support@po18.com',
    wechat: 'po18_official',
    qq: '400-888-1818',
    workingHours: '周一至周日 9:00 - 21:00',
    address: '中国上海市浦东新区张江高科技园区',
  },
};